import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/font/google/target.css?{\"path\":\"src/app/(frontend)/layout.tsx\",\"import\":\"Oswald\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-oswald\"}],\"variableName\":\"oswald\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredClientComponents"] */ "/app/src/components/DeferredClientComponents.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EmailObfuscator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredGTM"] */ "/app/src/components/GTM/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/app/src/components/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/app/src/Header/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/providers/index.tsx");
